import React, { useState } from "react";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { addFavorite, removeFavorite } from "../api/dealflowApi";

export default function FavoriteButton({ listingUlid, isFavorite = false, size = "md" }) {
  const qc = useQueryClient();
  // Optimistic local state — gets reconciled by query invalidation.
  const [active, setActive] = useState(isFavorite);

  const add = useMutation({
    mutationFn: () => addFavorite(listingUlid),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ["favorites"] });
    },
  });
  const remove = useMutation({
    mutationFn: () => removeFavorite(listingUlid),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ["favorites"] });
    },
  });

  const toggle = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (active) {
      setActive(false);
      remove.mutate();
    } else {
      setActive(true);
      add.mutate();
    }
  };

  const cls =
    size === "sm"
      ? "h-7 w-7 text-sm"
      : size === "lg"
        ? "h-10 w-10 text-lg"
        : "h-8 w-8 text-base";

  return (
    <button
      data-testid={`favorite-button-${listingUlid}`}
      onClick={toggle}
      className={`${cls} rounded-full border flex items-center justify-center transition ${
        active
          ? "bg-rose-500/20 border-rose-400 text-rose-300"
          : "bg-zinc-900/80 border-zinc-700 text-zinc-300 hover:text-rose-300 hover:border-rose-400"
      }`}
      title={active ? "Remove from favorites" : "Add to favorites"}
      aria-pressed={active}
    >
      {active ? "♥" : "♡"}
    </button>
  );
}
